var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnnotationTypeDraw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 80,
    viewBox: "0 0 180 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 80,
    rx: 40,
    fill: "#39BBBB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.5674 46V33.2031H81.3467C82.4775 33.2031 83.4795 33.4551 84.3525 33.959C85.2314 34.4629 85.9111 35.1777 86.3916 36.1035C86.8721 37.0293 87.1123 38.0898 87.1123 39.2852V39.9268C87.1123 41.1396 86.8691 42.2061 86.3828 43.126C85.9023 44.0459 85.2139 44.7549 84.3174 45.2529C83.4268 45.751 82.4043 46 81.25 46H77.5674ZM79.791 34.9961V44.2246H81.2412C82.4072 44.2246 83.3008 43.8613 83.9219 43.1348C84.5488 42.4023 84.8682 41.3535 84.8799 39.9883V39.2764C84.8799 37.8877 84.5781 36.8271 83.9746 36.0947C83.3711 35.3623 82.4951 34.9961 81.3467 34.9961H79.791ZM94.7793 41.0693H92.3008V46H90.0771V33.2031H94.5771C96.0537 33.2031 97.1934 33.5342 97.9961 34.1963C98.7988 34.8584 99.2002 35.8164 99.2002 37.0703C99.2002 37.9258 98.9922 38.6436 98.5762 39.2236C98.166 39.7979 97.5918 40.2402 96.8535 40.5508L99.7275 45.8857V46H97.3457L94.7793 41.0693ZM92.3008 39.2852H94.5859C95.3359 39.2852 95.9219 39.0977 96.3438 38.7227C96.7656 38.3418 96.9766 37.8232 96.9766 37.167C96.9766 36.4814 96.7803 35.9512 96.3877 35.5762C96.001 35.2012 95.4209 35.0078 94.6475 34.9961H92.3008V39.2852ZM109.223 43.0205H104.266L103.229 46H100.917L105.751 33.2031H107.746L112.589 46H110.269L109.223 43.0205ZM104.89 41.2275H108.599L106.744 35.9189L104.89 41.2275ZM124.483 42.8359L126.452 33.2031H128.658L125.705 46H123.578L121.144 36.6572L118.656 46H116.521L113.567 33.2031H115.773L117.76 42.8184L120.203 33.2031H122.066L124.483 42.8359Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4248 27.4142L64.3746 32.364L47.7916 48.9469L42.2083 49.4039L42.8288 44.0102L59.4248 27.4142Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnotationTypeDraw);
export default __webpack_public_path__ + "static/media/annotation_type_draw.ff59b968509965296ec5e556debfc95d.svg";
export { ForwardRef as ReactComponent };